import { Navigate } from 'react-router-dom'
import ComingSoon from '../components/ComingSoon'
import SubscriptionGate from '../components/Subscriptions/SubscriptionGate'
import AddNew from '../pages/governance/announcements/AddNew'
import Announcements from '../pages/governance/announcements/Announcements'
import SingleAnnouncement from '../pages/governance/announcements/SingleAnnouncement'
import CompleteAuditPage from '../pages/governance/audits/AuditForm'
import AuditLogPage from '../pages/governance/audits/AuditLog'
import AuditDescriptionsDashboard from '../pages/governance/audits/AuditsDashboard'
import EditAuditTemplatePage from '../pages/governance/audits/EditAudit'
import Feedback from '../pages/governance/feedback/Feedback'
import IncidentList from '../pages/governance/incidents/incidentList/incidentList'
import Incident from '../pages/governance/incidents/incidentPage/Incident'
import ReportIncident from '../pages/governance/incidents/reportNew/ReportIncident'
import SpeakUp from '../pages/governance/speakUp/SpeakUp'
import SpeakUpConcerns from '../pages/governance/speakUp/SpeakUpConcerns'
import SpeakUpConcern from '../pages/governance/speakUp/SpeakUpConcern'
import GovernanceActions from '../pages/governance/actions/GovernanceActions'
import KPIHome from '../pages/governance/kpi/KPIHome'
import KPISection from '../pages/governance/kpi/KPISection'
import KPITargetsSettings from '../pages/governance/kpi/KPITargetsSettings'
import KPI_SECTIONS from '../pages/governance/kpi/sections'
import MedsMxIndex from '../pages/governance/medsMx'
import MedicineAdministrations from '../pages/governance/medsMx/administrationRecords/Administrations'
import AdministrationSelect from '../pages/governance/medsMx/AdministrationSelect'
import Audit from '../pages/governance/medsMx/Audit'
import AuditPage from '../pages/governance/medsMx/audits/AuditPage'
import Audits from '../pages/governance/medsMx/audits/Audits'
import CreateCDAudit from '../pages/governance/medsMx/audits/ControlledDrugs/CreateCDAudit'
import ViewCDAudit from '../pages/governance/medsMx/audits/ControlledDrugs/ViewCDAudit'
import CDRegister from '../pages/governance/medsMx/cdRegister/CDRegister'
import CDRegisterLedger from '../pages/governance/medsMx/cdRegister/CDRegisterLedger'
import Discrepancies from '../pages/governance/medsMx/discrepancies/Discrepancies'
import DiscrepancyPage from '../pages/governance/medsMx/discrepancies/DiscrepancyPage'
import DrugBagPage from '../pages/governance/medsMx/drugbags/DrugBagPage'
import DrugBagSelector from '../pages/governance/medsMx/drugbags/DrugBagSelector'
import MedicineLocation from '../pages/governance/medsMx/MedicineLocation'
import MyPreparedMedicines from '../pages/governance/medsMx/prepared/MyPreparedMedicines'
import GovernancePreparedMedicines from '../pages/governance/medsMx/prepared/GovernancePreparedMedicines'
import CriticalCareGate from '../components/Subscriptions/CriticalCareGate'
import ViewAll from '../pages/governance/medsMx/ViewAll/ViewAll'
import MeetingPage from '../pages/governance/meetings/MeetingPage'
import Meetings from '../pages/governance/meetings/Meetings'
import NewMeeting from '../pages/governance/meetings/NewMeeting/NewMeeting'
import PGDLibrary from '../pages/governance/pgdLibrary/PGDLibrary'
import PGDPage from '../pages/governance/pgdLibrary/PGDPage'
import PolicyLibrary from '../pages/governance/policyLibrary/PolicyLibrary'
import PolicyPage from '../pages/governance/policyLibrary/PolicyPage'
import Register from '../pages/governance/riskRegister/Register'
import SingleRisk from '../pages/governance/riskRegister/SingleRisk/SingleRisk'
import SafetyAlerts from '../pages/governance/safetyAlerts/SafetyAlerts'
import SingleSOP from '../pages/governance/sops/SingleSOP'
import Sops from '../pages/governance/sops/Sops'
import IDCheck from '../pages/login/idcheck/IDCheck'
import EPCRDashboard from '../pages/patientRecords/ePCR/EPCRDashboard'
import MyRecentEPCRs from '../pages/patientRecords/reporting/myRecents/MyRecentEPCRs'
import AccessRecord from '../pages/patientRecords/Sharing/PublicAccess/AccessRecord'

export default [
  { path: '/announcements', element: <Announcements />, title: 'Announcements' },
  { path: '/announcements/add-new', element: <AddNew />, title: 'New Announcement' },
  { path: '/announcements/:id', element: <SingleAnnouncement />, title: 'Announcement' },
  { path: '/policy-library', element: <PolicyLibrary />,  title: 'Policy Library'},
  { path: '/policy-library/:policyId', element: <PolicyPage />},
  { path: '/standard-operating-procedures', element: <Sops />, title: 'SOPs' },
  { path: '/standard-operating-procedures/:id', element: <SingleSOP /> },
  {
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="PGDs"
        areNotIs
        caption="Manage Patient Group Directions with digital signatures, version control, and compliance tracking."
        benefits={[
          'Store and manage Patient Group Directions digitally.',
          'Allow healthcare professionals to sign PGDs electronically.',
          'Track versions, expiry dates, and review requirements.',
          'Control access to PGDs by clinical role.',
        ]}
      />
    ),
    children: [
      { path: '/pgd-library', element: <PGDLibrary />, title: 'PGD Library' },
      { path: '/pgd-library/:pgdID', element: <PGDPage /> },
    ],
  },
  { path: '/incidents', element: <IncidentList />, title: 'Adverse Incidents' },
  { path: '/incidents/:id', element: <Incident /> },
  { path: '/checkmedsbag', element: <DrugBagSelector />, title: 'Check Meds Bag' },
  { path: '/checkmedsbag/:id', element: <DrugBagPage /> },
  { path: '/medicines-management', element: <MedsMxIndex />, title: 'Medicines Management' },
  { path: '/medicines-management/record-audit/:bagID', element: <Audit /> },
  { path: '/medicines-management/audits', element: <Audits />, title: 'Medicine Audits' },
  { path: '/medicines-management/audits/:auditID', element: <AuditPage />,  },
  { path: '/medicines-management/discrepancies', element: <Discrepancies />, title: 'Medicine Discrepancies' },
  { path: '/medicines-management/discrepancies/:discrepancyID', element: <DiscrepancyPage /> },
  { path: '/medicines-management/cd-register', element: <CDRegister />, title: 'CD Register' },
  { path: '/medicines-management/cd-register/:descriptionID', element: <CDRegisterLedger /> },
  { path: '/medicines-management/viewall', element: <ViewAll />, title: 'Medicine Audits' },
  // { path: '/medicines-management/viewadministered', element: <MedsMxIndex /> },
  {
    path: '/medicines-management/administration',
    element: <AdministrationSelect />,
    title: 'Medicine Administration'
  },
  {
    path: '/medicines-management/administration-records',
    element: <MedicineAdministrations />,
    title: 'Administration Records'
  },
  { path: '/medicines-management/drawn-up', element: <CriticalCareGate><GovernancePreparedMedicines /></CriticalCareGate>, title: 'Drawn-up Medicines' },
  { path: '/drawn-up-medicines', element: <CriticalCareGate><MyPreparedMedicines /></CriticalCareGate>, title: 'My Drawn-up Medicines' },
  { path: '/medicines-management/:locationId', element: <MedicineLocation /> },
  { path: '/create-cd-audit/:employeeID', element: <CreateCDAudit />, title: 'CD Audit' },
  { path: '/cd-audit/:auditID', element: <ViewCDAudit />, title: 'CD Audits' },
  {
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="Risk Register"
        caption="dentify, assess, and monitor organisational risks in one central register."
        benefits={[
          'Record and categorise organisational risks.',
          'Track risk severity, controls, and mitigations.',
          'Monitor outstanding actions and review dates.',
          'Maintain an auditable governance risk register.',
        ]}
      />
    ),
    children: [
      { path: '/risk-register', element: <Register />, title: 'Risk Register' },
      { path: '/risk-register/:id', element: <SingleRisk /> },
    ],
  },
  { path: '/cqc-tracker', element: <Navigate to="/cqc-centre" replace /> },
  { path: '/id-check/:id', element: <IDCheck />, title: 'ID Check' },
  { path: '/feedback', element: <Feedback />, title: 'Feedback' },
  { path: '/report-incident', element: <ReportIncident />, title: 'Report an Incident' },
  { path: '/speak-up', element: <SpeakUp />, title: 'Speak Up' },
  { path: '/speak-up-concerns', element: <SpeakUpConcerns />, title: 'Speak up Concerns' },
  { path: '/speak-up-concerns/:id', element: <SpeakUpConcern />, title: 'Speak up Concerns' },
  // Optional :id opens the alert drawer (task links point here) — one route so
  // the list isn't remounted/refetched each time the drawer opens
  { path: '/safety-alerts/:id?', element: <SafetyAlerts />, title: 'Safety Alerts' },
  // { path: '/epcr', element: <EPCR /> }
  { path: '/epcr', element: <EPCRDashboard />, title: 'ePCR' },
  { path: '/epcr/recents', element: <MyRecentEPCRs />, title: 'Recent ePCRs' },
  { path: '/access-record', element: <AccessRecord />, title: 'ePCR' },
  { path: '/kpi', element: <KPIHome />, title: 'KPIs' },
  { path: '/kpi/settings', element: <KPITargetsSettings />, title: 'KPI Settings' },
  { path: '/governance-actions', element: <GovernanceActions />, title: 'Governance Actions' },
  ...KPI_SECTIONS.map((section) => ({
    path: `/kpi/${section.slug}`,
    element: <KPISection slug={section.slug} />,
    title: section.name
  })),

  {
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="Governance Meetings"
        benefits={[
          'Track governance actions, owners, and deadlines.',
          'Review incidents, complaints, and patient feedback.',
          'Record structured meeting minutes and decisions.',
          'Schedule recurring meetings with compliance oversight.',
        ]}
      />
    ),
    children: [
      { path: '/meetings', element: <Meetings />, title: 'Meetings' },
      { path: '/meetings/new', element: <NewMeeting />, title: 'New Meeting' },
      { path: '/meetings/:id', element: <MeetingPage /> },
    ],
  },
  {
    element: (
      <SubscriptionGate
        featureName="Audits"
        areNotIs
        caption="Complete, manage, and review operational and governance audits digitally."
        requiredTier={2}
        benefits={[
          'Complete a wide range of governance audits digitally.',
          'Create custom audit templates for your organisation.',
          'Track audit outcomes, actions, and compliance trends.',
          'Maintain a full audit trail for governance and inspections.',
        ]}
      />
    ),
    children: [
      {
        path: '/governance/audit-templates',
        element: <AuditDescriptionsDashboard />,
        title: 'Audit Templates'
      },
      {
        path: '/governance/audit-templates/edit/:id',
        element: <EditAuditTemplatePage />,
      },
      {
        path: '/governance/audit-templates/new',
        element: <EditAuditTemplatePage />,
        title: 'Audit Templates'
      },
      { path: '/governance/audit', element: <CompleteAuditPage />, title: 'Audit' },
      { path: '/governance/audits', element: <AuditLogPage />, title: 'Audits' },
    ],
  },
]
